import { Input, Select } from 'antd';
import css from './index.module.scss';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import { useGlobal } from '@/utils/useGlobal';
import { getCityList, getCountryList, getStateList, getStoreList, getTypeList, getTypeCodeList } from '@/service';
import EFZip from '@/components/UI/svg/WTB/EFZip';
import EFAddress from '@/components/UI/svg/WTB/EFAddress';

export default function ControlBox({ onBackStore, onBackCenter, onBackLogoCard, typeCode }: any) {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { t } = useLang('wheretobuy');
    const { locale } = useRouter();

    const [countryData, setCountryData] = useState([]);
    const [provinceData, setProvinceData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [typeData, setTypeData] = useState([]);

    const [countryOpen, setCountryOpen] = useState(false);
    const [provinceOpen, setProvinceOpen] = useState(false);
    const [cityOpen, setCityOpen] = useState(false);
    const [typeOpen, setTypeOpen] = useState(false);

    const [searchCountry, setSearchCountry] = useState(null);
    const [searchProvince, setSearchProvince] = useState(null);
    const [searchCity, setSearchCity] = useState(null); // 仅中国站
    const [searchType, setSearchType] = useState(null);
    const [searchText, setSearchText] = useState('');

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const SEARCH_VAR_SITES: string[] = ['us', 'ca', 'de', 'au', 'ph', 'jp', 'it', 'es', 'fr', 'eu', 'uk', 'br', 'mx'];
    const SEARCH_VAR_SITES_STORE: string[] = ['sa'];
    const [expanded, setExpanded] = useState(false);
    const [searchVar, setSearchVar] = useState(SEARCH_VAR_SITES.includes(locale) ? 'zip' : SEARCH_VAR_SITES_STORE.includes(locale) ? 'text' : ''); // text => 地址或店名, zip => 邮编 两种
    const [countryStores, setCountryStores] = useState([]);
    const LOCAL_MAP: any = {
        de: 'Germany',
        it: 'Italy',
        es: 'Spain',
        fr: 'France',
        us: 'United States',
        au: 'Australia',
        ph: 'Philippines',
        jp: 'Japan',
        lu: 'Luxembourg',
        cn: 'China',
        ca: 'Canada',
        eu: 'Germany',
        uk: 'United Kingdom',
        sa: 'Saudi Arabia',
        br: 'Brasil',
        mx: 'Mexico',
    };

    const latlngMap: any = {
        us: {
            lat: 38.0,
            lng: -77.0,
        },
        au: {
            lat: -35.2,
            lng: 149.0,
        },
        ph: {
            lat: 14.6,
            lng: 121,
        },
        jp: {
            lat: 35.6,
            lng: 139.6,
        },
        cn: {
            lat: 39.9,
            lng: 116.4,
        },
        de: {
            lat: 52.5,
            lng: 13.4,
        },
        it: {
            lat: 41.9,
            lng: 12.5,
        },
        es: {
            lat: 40.4,
            lng: -3.7,
        },
        fr: {
            lat: 48.86,
            lng: 2.35,
        },
        eu: {
            lat: 52.5,
            lng: 13.4,
        },
        uk: {
            lat: 51.5,
            lng: -0.1,
        },
        br: {
            lat: -15.7,
            lng: -47.9,
        },
        mx: {
            lat: 19.4,
            lng: -99.1,
        },
    };

    const onChangeSearch = (value: string) => {
        setSearchVar(value);
        if (['de', 'fr'].includes(locale)) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'tab_click',
                list_name: t('title'),
                button_name: value === 'zip' ? t('search_item_zip') : t('search_item_address'),
            });
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'option_click',
                button_name: value === 'zip' ? t('search_item_zip') : t('search_item_address'),
            });
        }
    };

    const selectBefore: any = (
        <Select
            defaultValue={searchVar}
            open={expanded}
            onDropdownVisibleChange={setExpanded}
            onChange={(value) => onChangeSearch(value)}
            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
            suffixIcon={
                ['zip', 'text'].includes(searchVar) ? (
                    <>
                        {searchVar === 'zip' ? <EFZip className="svg-icon" /> : <EFAddress className="svg-icon" />}
                        <svg
                            className={`svg-arrow ${expanded ? 'open' : 'close'}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                        >
                            <path
                                d="M2.89534 7.69762L5.99995 4.62117L9.10456 7.69762C9.24026 7.83209 9.40735 7.9 9.59995 7.9C9.79255 7.9 9.95964 7.83209 10.0953 7.69762C10.2311 7.56311 10.3 7.39711 10.3 7.20544C10.3 7.01377 10.2311 6.84777 10.0953 6.71326L6.49534 3.14592L6.42627 3.21562L6.49534 3.14592C6.3437 2.99566 6.18141 2.9054 6.0092 2.90023C5.83547 2.89502 5.67503 2.977 5.52956 3.12115L1.90456 6.71326C1.76883 6.84777 1.69995 7.01377 1.69995 7.20544C1.69995 7.39711 1.76883 7.56311 1.90456 7.69762C2.04027 7.83209 2.20735 7.9 2.39995 7.9C2.59255 7.9 2.75964 7.83209 2.89534 7.69762Z"
                                fill="#919191"
                                stroke="#919191"
                                strokeWidth="0.2"
                            />
                        </svg>
                    </>
                ) : null
            }
        >
            <Select.Option value="zip">
                <>
                    <EFZip />
                    <span className="option-text">{t('search_item_zip')}</span>
                </>
            </Select.Option>
            <Select.Option value="text">
                <>
                    <EFAddress />
                    <span className="option-text">{t('search_item_address')}</span>
                </>
            </Select.Option>
        </Select>
    );

    // 根据国家解析固定门店类型（typeCode -> name），仅在传入 typeCode 时生效
    const resolveFixedTypeName = async (country: string) => {
        if (!typeCode) {
            return undefined;
        }
        const res: any = await getTypeCodeList({ country }, locale);
        if (res?.code === '0') {
            const matched = res?.data?.find((item: any) => String(item?.typeCode) === String(typeCode));
            return matched?.name;
        }
        return undefined;
    };

    const onSearch = async (v: string) => {
        const params: any = {};
        if (searchCountry) {
            params.country = searchCountry;
        }
        if (searchProvince) {
            params.state = searchProvince;
        }
        if (searchCity && locale === 'cn') {
            params.city = searchCity;
        }
        if (searchType) {
            params.type = searchType;
        }
        searchVar === 'zip' ? (params.zipCode = v) : (params.fuzzyStr = v);
        const res = await getStoreList(params, locale);
        if (res.code === '0') {
            // 更新门店数据
            onBackStore(res.data);
            // 切换更新地图中心
            const firstItem = res.data.length > 0 && res.data[0];
            if (firstItem?.latitude && firstItem?.longitude) {
                onBackCenter({ lat: Number(firstItem?.latitude), lng: Number(firstItem?.longitude) });
            }
        }
    };

    const onSearchChange: any = (e: any) => {
        setSearchText(e?.target?.value);
    };

    const onChangeCountry = async (_k: any, v: any) => {
        if (v && v?.value) {
            onBackLogoCard({ show: false, data: {} });
            // 1. 请求省/州数据
            const res = await getStateList({ country: v.value }, locale);
            if (res.code === '0') {
                setProvinceData(res.data);
                setSearchCountry(v.value);
                setSearchProvince(null);
                setSearchType(null);
            }
            // 2. 更新地图门店数据（选中国家下的）
            const params: any = { country: v.value };
            // 有 typeCode 时，按新国家重新解析固定门店类型并带上
            if (typeCode) {
                const typeName = await resolveFixedTypeName(v.value);
                setSearchType(typeName ?? null);
                if (!typeName) {
                    // 新国家没有对应的固定门店类型：不请求门店，直接清空数据
                    onBackStore([]);
                    onBackCenter(latlngMap[v.value.toLowerCase()] || latlngMap.us);
                    return;
                }
                params.type = typeName;
            } else if (searchType) {
                params.type = searchType;
            }
            if (searchText) {
                searchVar === 'zip' ? (params.zipCode = searchText) : (params.fuzzyStr = searchText);
            }
            const resStores = await getStoreList(params, locale);
            if (resStores.code === '0') {
                // 更新门店数据
                onBackStore(resStores.data);
                // 切换更新地图中心（国家级）
                const center = resStores.data?.length > 0 ? { lat: Number(resStores.data[0].latitude), lng: Number(resStores.data[0].longitude) } : null;
                onBackCenter(center || latlngMap[v.value.toLowerCase()] || latlngMap.us);
            }
            // 3. 更新类型（仅无 typeCode 时需要下拉数据）
            if (locale !== 'cn' && !typeCode) {
                const resType = await getTypeList({ country: v.value }, locale);
                if (resType.code === '0') {
                    setTypeData(resType.data);
                }
            }
        }
    };

    const onChangeProvince = async (_k: any, v: any) => {
        if (v && v.value) {
            onBackLogoCard({ show: false, data: {} });
            // 1. 请求城市数据
            const res = await getCityList({ country: searchCountry, state: v.value }, locale);
            if (res.code === '0') {
                setSearchProvince(v.value);
                if (locale === 'cn') {
                    setCityData(res.data);
                    setSearchCity(null);
                }
            }
            // 2. 更新地图门店数据（选中省/州下的）
            const params: any = { country: searchCountry, state: v.value };
            if (searchType) {
                params.type = searchType;
            }
            if (searchText) {
                searchVar === 'zip' ? (params.zipCode = searchText) : (params.fuzzyStr = searchText);
            }
            const resStores = await getStoreList(params, locale);
            if (resStores.code === '0') {
                // 更新门店数据
                onBackStore(resStores.data);
                // 切换更新地图中心(省/州级、默认取第一个数据的经纬度)
                const firstItem = resStores.data.length > 0 && resStores.data[0];
                if (firstItem?.latitude && firstItem?.longitude) {
                    onBackCenter({ lat: Number(firstItem?.latitude), lng: Number(firstItem?.longitude) });
                }
            }
        }
    };

    const onChangeCity = async (_k: any, v: any) => {
        if (v && v?.value) {
            onBackLogoCard({ show: false, data: {} });
            setSearchCity(v.value);
            // 2. 更新地图门店数据（选中城市下的）
            const params: any = { country: 'CN', state: searchProvince, city: v.value };
            if (searchType) {
                params.type = searchType;
            }
            if (searchText) {
                searchVar === 'zip' ? (params.zipCode = searchText) : (params.fuzzyStr = searchText);
            }
            const resStores = await getStoreList(params, locale);
            if (resStores.code === '0') {
                // 更新门店数据
                onBackStore(resStores.data);
                // 切换更新地图中心(省/州级、默认取第一个数据的经纬度)
                const firstItem = resStores.data.length > 0 && resStores.data[0];
                if (firstItem?.latitude && firstItem?.longitude) {
                    onBackCenter({ lat: Number(firstItem?.latitude), lng: Number(firstItem?.longitude) });
                }
            }
        }
    };

    const onChangeType = async (_k: any, v: any) => {
        if (v && v?.value) {
            onBackLogoCard({ show: false, data: {} });
            setSearchType(v.value);
            // 更新地图门店数据（选中类型下的）
            const params: any = { type: v.value };
            if (searchText) {
                searchVar === 'zip' ? (params.zipCode = searchText) : (params.fuzzyStr = searchText);
            }
            if (searchCountry) {
                params.country = searchCountry;
            }
            if (searchProvince) {
                params.state = searchProvince;
            }
            if (searchCity && locale === 'cn') {
                params.city = searchCity;
            }
            const resStores = await getStoreList(params, locale);
            if (resStores.code === '0') {
                // 更新门店数据
                onBackStore(resStores.data);
                // 切换更新地图中心(默认取第一个数据的经纬度)
                const firstItem = resStores.data.length > 0 && resStores.data[0];
                if (firstItem?.latitude && firstItem?.longitude) {
                    onBackCenter({ lat: Number(firstItem?.latitude), lng: Number(firstItem?.longitude) });
                }
            }
        }
    };

    useEffect(() => {
        if (locale !== 'cn') {
            getCountryList(locale).then((res: any) => {
                if (res.code === '0') {
                    setCountryData(res.data);
                }
            });
        }
        const defaultCountry = LOCAL_MAP[locale] || locale?.toUpperCase();
        // 默认展示当前站点国家
        getStateList({ country: defaultCountry }, locale).then((res: any) => {
            if (res.code === '0') {
                // @吴楠 后台管理德国数据并不是DE，而是Germany,特出处理
                setSearchCountry(defaultCountry);
                setProvinceData(res.data);
            }
        });
        // 请求门店（如果有固定门店类型则带上 type）
        const loadStores = (typeName?: string) => {
            const params: any = { country: defaultCountry };
            if (typeName) {
                params.type = typeName;
            }
            getStoreList(params, locale).then((res: any) => {
                if (res.code === '0') {
                    // 更新门店数据
                    onBackStore(res.data);
                    setCountryStores(res.data);
                    // 切换更新地图中心（国家级）
                    const center = res.data?.length > 0 ? { lat: Number(res.data[0].latitude), lng: Number(res.data[0].longitude) } : null;
                    onBackCenter(center || latlngMap[locale.toLowerCase()] || latlngMap.us);
                }
            });
        };

        if (typeCode) {
            // 传入了 typeCode：按国家解析出固定门店类型，再带类型请求门店
            resolveFixedTypeName(defaultCountry).then((typeName: any) => {
                if (typeName) {
                    // 固定门店类型，后续所有查询都会带上该类型
                    setSearchType(typeName);
                    loadStores(typeName);
                } else {
                    // 该国家没有对应的固定门店类型：不请求门店，直接清空数据
                    setSearchType(null);
                    onBackStore([]);
                    setCountryStores([]);
                    onBackCenter(latlngMap[locale.toLowerCase()] || latlngMap.us);
                }
            });
        } else {
            // 没有 typeCode：原逻辑，请求门店 + 类型下拉数据
            loadStores();
            getTypeList({ country: defaultCountry }, locale).then((res: any) => {
                if (res.code === '0') {
                    setTypeData(res.data);
                }
            });
        }
    }, []);

    useEffect(() => {
        const hasZipStore = countryStores?.some((list: any) => Boolean(list?.zipCode));
        if (hasZipStore && SEARCH_VAR_SITES.includes(locale)) {
            !searchVar && setSearchVar('zip');
        } else if (SEARCH_VAR_SITES_STORE.includes(locale)) {
            !searchVar && setSearchVar('text');
        } else {
            setSearchVar('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SEARCH_VAR_SITES, SEARCH_VAR_SITES_STORE, locale, countryStores]);

    return (
        <div className={css.controlBox}>
            {/* {typeCode + '---' + } */}
            <div className="searchBox">
                <Input.Search
                    className={`${(SEARCH_VAR_SITES.includes(locale) || SEARCH_VAR_SITES_STORE.includes(locale)) && searchVar ? 'search-var' : ''}`}
                    addonBefore={(SEARCH_VAR_SITES.includes(locale) || SEARCH_VAR_SITES_STORE.includes(locale)) && searchVar ? selectBefore : null}
                    placeholder={searchVar === 'zip' ? t('placeholder_search_zip') : t('placeholder_search_address')}
                    size="large"
                    onSearch={onSearch}
                    onChange={onSearchChange}
                />
            </div>
            <div className={`rightBox ${provinceData?.length > 0 ? 'short' : 'long'}`} style={{ width: typeCode ? '512px' : '744px' }}>
                {locale !== 'cn' && (
                    <div className="countryBox controlItem">
                        <Select
                            placeholder={t('placeholder_country')}
                            notFoundContent={t('select_nodata')}
                            onChange={onChangeCountry}
                            onDropdownVisibleChange={(open: boolean) => {
                                if (open) {
                                    document.body.style.overflow = 'hidden'; // 阻止外层页面滚动
                                } else {
                                    document.body.style.overflow = ''; // 恢复外层页面滚动
                                }
                                if (open && !countryOpen) {
                                    return setCountryOpen(true);
                                }
                                if (!open && countryOpen) {
                                    return setCountryOpen(false);
                                }
                            }}
                            allowClear={true}
                            onClear={async () => {
                                if (locale !== 'cn') {
                                    setSearchCountry(null);
                                }
                                if (locale === 'cn') {
                                    setSearchCity(null);
                                }
                                setSearchProvince(null);
                                setProvinceData([]);
                                setSearchType(null);
                                setTypeData([]);
                                // 重新请求数据
                                const params: any = { country: locale?.toUpperCase() };
                                if (searchText) {
                                    params.fuzzyStr = searchText;
                                }
                                const res = await getStoreList(params, locale);
                                if (res?.code === '0') {
                                    onBackStore(res.data);
                                    setCountryStores(res.data);
                                    // 切换更新地图中心(默认取第一个数据的经纬度)
                                    const firstItem = res.data.length > 0 && res.data[0];
                                    if (firstItem?.latitude && firstItem?.longitude) {
                                        onBackCenter({ lat: Number(firstItem?.latitude), lng: Number(firstItem?.longitude) });
                                    }
                                }
                            }}
                            value={searchCountry}
                            options={countryData.map((country: any) => ({ label: country, value: country }))}
                            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                            suffixIcon={
                                <span
                                    style={{
                                        display: 'block',
                                        transition: 'all 0.3s ease-in-out',
                                        transform: countryOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                    }}
                                >
                                    <EFArrowDown style={{ fontSize: '15px' }} />
                                </span>
                            }
                        />
                    </div>
                )}
                {provinceData?.length > 0 && (
                    <div className="provinceBox controlItem">
                        <Select
                            placeholder={t('placeholder_province')}
                            notFoundContent={t('select_nodata')}
                            onChange={onChangeProvince}
                            onDropdownVisibleChange={(open: boolean) => {
                                if (open) {
                                    document.body.style.overflow = 'hidden'; // 阻止外层页面滚动
                                } else {
                                    document.body.style.overflow = ''; // 恢复外层页面滚动
                                }
                                if (open && !provinceOpen) {
                                    return setProvinceOpen(true);
                                }
                                if (!open && provinceOpen) {
                                    return setProvinceOpen(false);
                                }
                            }}
                            allowClear={true}
                            onClear={async () => {
                                setSearchProvince(null);
                                if (locale === 'cn') {
                                    setCityData([]);
                                    setSearchCity(null);
                                }
                                // 重新请求数据
                                const params: any = { country: searchCountry };
                                if (searchText) {
                                    params.fuzzyStr = searchText;
                                }
                                if (searchType) {
                                    params.type = searchType;
                                }
                                const res = await getStoreList(params, locale);
                                if (res?.code === '0') {
                                    onBackStore(res.data);
                                    // 切换更新地图中心(默认取第一个数据的经纬度)
                                    const firstItem = res.data.length > 0 && res.data[0];
                                    if (firstItem?.latitude && firstItem?.longitude) {
                                        onBackCenter({ lat: Number(firstItem?.latitude), lng: Number(firstItem?.longitude) });
                                    }
                                }
                            }}
                            value={searchProvince}
                            options={provinceData.map((province: any) => ({ label: province, value: province }))}
                            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                            suffixIcon={
                                <span
                                    style={{
                                        display: 'block',
                                        transition: 'all 0.3s ease-in-out',
                                        transform: provinceOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                    }}
                                >
                                    <EFArrowDown style={{ fontSize: '15px' }} />
                                </span>
                            }
                        />
                    </div>
                )}
                {locale === 'cn' && (
                    <div className="cityBox controlItem">
                        <Select
                            placeholder={t('placeholder_city')}
                            notFoundContent={t('select_nodata')}
                            onChange={onChangeCity}
                            onDropdownVisibleChange={(open: boolean) => {
                                if (open) {
                                    document.body.style.overflow = 'hidden'; // 阻止外层页面滚动
                                } else {
                                    document.body.style.overflow = ''; // 恢复外层页面滚动
                                }
                                if (open && !cityOpen) {
                                    return setCityOpen(true);
                                }
                                if (!open && cityOpen) {
                                    return setCityOpen(false);
                                }
                            }}
                            allowClear={true}
                            onClear={async () => {
                                setSearchCity(null);
                                // 重新请求数据
                                const params: any = { country: searchCountry, state: searchProvince };
                                if (searchText) {
                                    params.fuzzyStr = searchText;
                                }
                                if (searchType) {
                                    params.type = searchType;
                                }
                                const res = await getStoreList(params, locale);
                                if (res?.code === '0') {
                                    onBackStore(res.data);
                                    // 切换更新地图中心(默认取第一个数据的经纬度)
                                    const firstItem = res.data.length > 0 && res.data[0];
                                    if (firstItem?.latitude && firstItem?.longitude) {
                                        onBackCenter({ lat: Number(firstItem?.latitude), lng: Number(firstItem?.longitude) });
                                    }
                                }
                            }}
                            value={searchCity}
                            options={cityData.map((city: any) => ({ label: city, value: city }))}
                            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                            suffixIcon={
                                <span
                                    style={{
                                        display: 'block',
                                        transition: 'all 0.3s ease-in-out',
                                        transform: cityOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                    }}
                                >
                                    <EFArrowDown style={{ fontSize: '15px' }} />
                                </span>
                            }
                        />
                    </div>
                )}
                {!typeCode && (
                    <div className="storeBox controlItem">
                        <Select
                            placeholder={t('placeholder_type')}
                            notFoundContent={t('select_nodata')}
                            onChange={onChangeType}
                            onDropdownVisibleChange={(open: boolean) => {
                                if (open) {
                                    document.body.style.overflow = 'hidden'; // 阻止外层页面滚动
                                } else {
                                    document.body.style.overflow = ''; // 恢复外层页面滚动
                                }
                                if (open && !typeOpen) {
                                    return setTypeOpen(true);
                                }
                                if (!open && typeOpen) {
                                    return setTypeOpen(false);
                                }
                            }}
                            value={searchType}
                            allowClear={true}
                            onClear={async () => {
                                setSearchType(null);
                                // 重新请求数据
                                const params: any = { country: searchCountry };
                                if (searchProvince) {
                                    params.state = searchProvince;
                                }
                                if (searchCity) {
                                    params.state = searchCity;
                                }
                                const res = await getStoreList(params, locale);
                                if (res?.code === '0') {
                                    onBackStore(res.data);
                                    // 切换更新地图中心(默认取第一个数据的经纬度)
                                    const firstItem = res.data.length > 0 && res.data[0];
                                    if (firstItem?.latitude && firstItem?.longitude) {
                                        onBackCenter({ lat: Number(firstItem?.latitude), lng: Number(firstItem?.longitude) });
                                    }
                                }
                            }}
                            options={typeData.map((type: any) => ({ label: type, value: type }))}
                            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                            suffixIcon={
                                <span
                                    style={{
                                        display: 'block',
                                        transition: 'all 0.3s ease-in-out',
                                        transform: typeOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                    }}
                                >
                                    <EFArrowDown style={{ fontSize: '15px' }} />
                                </span>
                            }
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
